import { Routes } from '@angular/router';
import { stepAccessGuard } from './core/guards/step-access.guard';
import { confirmExitGuard } from './core/guards/confirm-exit.guard';

export const routes: Routes = [
    // Validacion de poliza
    {
        path: 'certificado',
        loadComponent: () => import('./pages/certificado/certificado.component').then(c => c.CertificadoComponent),
        children: [
            {
                path: '',
                redirectTo: 'consulta',
                pathMatch: 'full'
            },
            {
                path: 'consulta',
                loadComponent: () => import('./pages/certificado/consulta-certificado/consulta-certificado.component').then(c => c.ConsultaCertificadoComponent)
            },
            {
                path: 'detalle',
                loadComponent: () => import('./pages/certificado/detalle-certificado/detalle-certificado.component').then(c => c.DetalleCertificadoComponent)
            }
        ]
    },
    {
        path: 'beneficiarios',
        loadComponent: () => import('./pages/beneficiarios/beneficiarios.component').then(c => c.BeneficiariosComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () => import('./pages/beneficiarios/landing/landing.component').then(c => c.LandingComponent)
            },
            {
                path: 'resumen',
                loadComponent: () => import('./pages/beneficiarios/resumen-beneficiarios/resumen-beneficiarios.component').then(c => c.ResumenBeneficiariosComponent),
                data: { access: 'requiresCompleted' },
                canActivate: [stepAccessGuard]
            },
            {
                path: 'registro',
                loadComponent: () => import('./pages/beneficiarios/registro-beneficiarios/registro-beneficiarios.component').then(c => c.RegistroBeneficiariosComponent),
                children: [
                    {
                        path: '',
                        redirectTo: 'identificacion',
                        pathMatch: 'full'
                    },
                    {
                        path: 'identificacion',
                        loadComponent: () => import('./pages/beneficiarios/registro-beneficiarios/identificacion/identificacion.component').then(c => c.IdentificacionComponent),
                        data: { access: 'public', stepIndex: 0 }
                    },
                    {
                        path: 'verificar-correo',
                        loadComponent: () => import('./pages/beneficiarios/registro-beneficiarios/otp/otp.component').then(c => c.OtpComponent),
                        data: { access: 'requiresIdentified', stepIndex: 1 },
                        canActivate: [stepAccessGuard]
                    },
                    {
                        path: 'nuevo-beneficiario',
                        loadComponent: () => import('./pages/beneficiarios/registro-beneficiarios/nuevo-beneficiario/nuevo-beneficiario.component').then(c => c.NuevoBeneficiarioComponent),
                        data: { access: 'requiresOtpForm', stepIndex: 2 },
                        canActivate: [stepAccessGuard],
                        canDeactivate: [confirmExitGuard]
                    },
                    {
                        path: 'revision',
                        loadComponent: () => import('./pages/beneficiarios/registro-beneficiarios/revision-beneficiarios/revision-beneficiarios.component').then(c => c.RevisionBeneficiariosComponent),
                        data: { access: 'requiresAdded', stepIndex: 3 },
                        canActivate: [stepAccessGuard],
                        canDeactivate: [confirmExitGuard]
                    }
                ]
            }
        ]
    },
    { path: '', redirectTo: 'certificado', pathMatch: 'full' },
    { path: '**', redirectTo: 'certificado' }
];
